import { useEffect, useRef } from 'react';
import { trackEvent } from '../utils/analytics';

const THRESHOLDS = [50, 90];

// Drop into a page next to <SEO /> to fire `scroll_depth` events at 50% and 90%
// of the document. Each threshold fires at most once per mount; remounting on
// a route change resets the state.
export default function ScrollDepthTracker({ pageCategory, pageName }) {
  const firedRef = useRef(new Set());

  useEffect(() => {
    firedRef.current = new Set();
    let frame = null;

    const measure = () => {
      frame = null;
      const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
      const viewport = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;
      const scrollable = fullHeight - viewport;
      if (scrollable <= 0) return;

      const percent = (scrollTop / scrollable) * 100;
      for (const threshold of THRESHOLDS) {
        if (percent >= threshold && !firedRef.current.has(threshold)) {
          firedRef.current.add(threshold);
          trackEvent('scroll_depth', {
            page_category: pageCategory,
            page_name: pageName,
            threshold,
          });
        }
      }
    };

    const onScroll = () => {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(measure);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    measure();

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (frame !== null) window.cancelAnimationFrame(frame);
    };
  }, [pageCategory, pageName]);

  return null;
}
